import templateUrl from "emun.invoice/credit-request/credit-request-list-grid.htm";
export default () => ({ templateUrl });
